var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile-elements-content-wrapper",attrs:{"id":"students"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }